//BUYERS Listing
export const FETCH_PCREPORT_LISTING_FAILURE = 'FETCH_PCREPORT_LISTING_FAILURE';
export const FETCH_PCREPORT_LISTING_SUCCESS = 'FETCH_PCREPORT_LISTING_SUCCESS';

export const RESET = 'RESET';
